module.exports = __webpack_public_path__ + "img/block-center-medium.8bd3e759.png";